<template>
    <div style="height: 100vh;">
        <iframe name="fd-jspdf" id="fd-jspdf" :src="`/static/pdf/web/viewer.html?file=${pdfUrl}`" width="100%"
            height="100%"></iframe>
    </div>
</template>
<script>
export default {
    name: 'appCommonPdf',
    props: {
        pdfUrl: {
            type: String,
            default: ''
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pdf/index.vue